<div class="container-block">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
        <!-- Chọn option nền cho frame blank -->
        <app-background-image-config [hasConfigGroup]="true" [configFieldName]="'frame-blank'"
        [elementChoosing]="objectChoosing"
        [config]="config"
        [class]="class"
        [backgroundClass]="class['frame-blank']"
        [backgroundConfig]="config['frame-blank']"
        [isBlock]="false"
        [id_object]="objectChoosing._id"
        [device]="device"
      >
      </app-background-image-config>
      <div class="mr-2 mb-4 mt-4 view-more" style="
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 7px;
      " *ngIf="config['frame-blank'].option_background == 'color'">
        <p class="discover_text" (click)="openViewAll(stylesField[2])"
          style="cursor: pointer; text-align: left; margin: 0">
          {{'mo_rong' | translate}} &#8594;
        </p>
      </div>

      <app-borders-config
        [elementChoosing]="objectChoosing"
        [device]="device"
        [class]="class"
        [borderClass]="class['frame-blank']"
        [id_object]="objectChoosing._id"
      >
      </app-borders-config>
      <p>{{'bo_tron' | translate}}</p>
      <app-borders-radius-config
          [elementChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [borderRadiusClass]="class['frame-blank']"
          [id_object]="objectChoosing._id"
        >
        </app-borders-radius-config>
    </div>


  </ng-container>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <div style="margin-top: 10px;"></div>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li
        nz-submenu
        nzTitle="{{'thong_so_co_ban' | translate}}"
        [(nzOpen)]="openMenu.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="main-config">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <!-- Chọn option nền cho frame blank -->
          <app-background-image-config [hasConfigGroup]="true" [configFieldName]="'frame-blank'"
            [elementChoosing]="objectChoosing"
            [config]="config"
            [class]="class"
            [backgroundClass]="class['frame-blank']"
            [backgroundConfig]="config['frame-blank']"
            [isBlock]="false"
            [id_object]="objectChoosing._id"
            [device]="device"
          >
          </app-background-image-config>
          <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          " *ngIf="config['frame-blank'].option_background == 'color'">
            <p class="discover_text" (click)="openViewAll(stylesField[2])"
              style="cursor: pointer; text-align: left; margin: 0">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>

          <!-- Vị trí khi cuộn trang -->
          <div class="mt-5 mb-3">
            <div class="title mb-2">{{'vi_tri_khi_cuon_trang' | translate}}</div>
            <nz-select
              [(ngModel)]="config['position_onscroll']['type']"
              (ngModelChange)="updateConfig()">
              <nz-option [nzValue]="0" [nzLabel]="'binh_thuong' | translate"></nz-option>
              <nz-option [nzValue]="1" [nzLabel]="'co_dinh_o_top' | translate"></nz-option>
            </nz-select>
            <div *ngIf="config['position_onscroll']['type'] != '0'"
              class="mt-4">
              <div class="config-name mt-0">
                <p>{{'canh_le_tren' | translate}}</p>
                <nz-input-number
                  [nzMin]="-100"
                  [nzMax]="1000"
                  [(ngModel)]="config['position_onscroll']['top']"
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div>
            </div>
            <!-- Phạm vi cố định -->
            <div *ngIf="config['position_onscroll']['type'] != '0'">
              <div class="title mb-2">{{'pham_vi_co_dinh' | translate}}</div>
              <nz-select [(ngModel)]="config['position_onscroll']['scope']"
                (ngModelChange)="updateConfig()">
                <nz-option nzValue="block" [nzLabel]="'trong_block_cha' | translate"></nz-option>
                <nz-option nzValue="page" [nzLabel]="'toan_trang' | translate"></nz-option>
              </nz-select>
            </div>
          </div>
        </div>
      </li>
      
      <!-- Cấu hình filter -->
      <li *ngIf="config['frame-blank']?.option_background == 'image'" nz-submenu nzTitle="{{'anh_sang_va_tuong_phan'| translate}}"
      [(nzOpen)]="openMenu.menu8" (nzOpenChange)="openHandler('menu8')">
        <app-brightness-contrast-config [elementChoosing]="objectChoosing"  [device]="device" [class]="class" [config]="config"
          [filterConfig]="config['filter']" [opacityClass]="class['frame-blank__boundary']" [staticdata]="staticdata"
          [id_object]="objectChoosing._id" [configType]="'background-image'">
        </app-brightness-contrast-config>
      </li>
      
      <!-- Cấu hình đường viền chung -->
      <li
        nz-submenu
        nzTitle="{{'duong_vien_chung' | translate}}"
        [(nzOpen)]="openMenu.menu3"
        (nzOpenChange)="openHandler('menu3')"
      >
        <app-borders-config
          [elementChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [borderClass]="class['frame-blank']"
          [id_object]="objectChoosing._id"
        >
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border" style="float: right">
          <p class="m-0 title-border" (click)="openViewAll(stylesField[0])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li
        nz-submenu
        nzTitle="{{'do_bong' | translate}}"
        [(nzOpen)]="openMenu.menu4"
        (nzOpenChange)="openHandler('menu4')"
      >
        <!-- Đổ bóng -->
        <app-shadow-config
          [device]="device"
          [config]="config"
          [class]="class"
          [shadowClass]="class['frame-blank']"
          [shadowConfig]="config['box-shadow']"
          [objectChoosing]="objectChoosing"
        >
        </app-shadow-config>
      </li>

      <!-- canh lề -->
      <li nz-submenu nzTitle="{{'canh_le' | translate}}" nzIcon="" [(nzOpen)]="openMenu.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <div>
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['frame-blank']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
          </app-padding-config>
        </div>
      </li>

      <!-- Cấu hình xoay -->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMenu.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <app-rotate-config [classRotate]="class['frame-blank']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>

      <!-- Cấu hình cuộn -->
      <li nz-submenu nzTitle="{{'cau_hinh_cuon' | translate}}" [(nzOpen)]="openMenu.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <div class="d-flex justify-content-between align-items-center my-2">
          <span class="w-50">{{ "cuon_trang" | translate}}</span>
          <nz-switch [ngModel]="config['-webkit-scrollbar']?.is_scroll"
          (ngModelChange)="toggleScrollFrame($event)">
          </nz-switch>
        </div>
        <!-- Cấu hình thanh cuộn -->
        <ng-container *ngIf="config['-webkit-scrollbar']?.is_scroll">
          <!-- Độ rộng thanh cuộn -->
          <div>
            <div class="config-name">
              <p>{{'do_rong_thanh_cuon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100"
                [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" 
                [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </div>
          <!-- Bo góc thanh cuộn -->
          <div>
            <div class="config-name">
              <p>{{'bo_goc_thanh_cuon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100"
                [ngModel]="config['-webkit-scrollbar']['border_radius'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['border_radius'] = $event +'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" 
                [ngModel]="config['-webkit-scrollbar']['border_radius'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['border_radius'] = $event +'px'"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </div>
          <!-- Màu nền thanh cuộn -->
          <div class="config-name mt-4">
            <p>{{'mau_nen_thanh_cuon' | translate}}</p>
            <div>
              <input class="input-color" type="button"
                [cpOKButton]="true" 
                [style.background]="config['-webkit-scrollbar']['background_color']"
                [(colorPicker)]="config['-webkit-scrollbar']['background_color']"
                (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Màu thanh cuộn -->
          <div class="config-name mt-4">
            <p>{{'mau_thanh_keo' | translate}}</p>
            <div>
              <input class="input-color" type="button"
                [cpOKButton]="true" 
                [style.background]="config['-webkit-scrollbar']['thumb_background_color']"
                [(colorPicker)]="config['-webkit-scrollbar']['thumb_background_color']"
                (colorPickerClose)="updateConfig()" />
            </div>
          </div>
        </ng-container>
      </li>

      <!-- Cấu hình hiệu ứng -->
      <li
        nz-submenu
        nzTitle="{{'hieu_ung' | translate}}"
        [(nzOpen)]="openMenu.menu6"
        (nzOpenChange)="openHandler('menu6')"
      >
        <app-choose-animations-config
          [elementChoosing]="objectChoosing"
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="staticdata"
          [cursorClass]="class['frame-blank']"
          [effect_hover]="effect_hover"
          [customize]="customize"
          [effectFileUsing]="'frame-blank'"
        >
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <div class="editor-header">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
    </div>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
        [elementChoosing]="objectChoosing"
        [device]="device"
        [class]="class"
        [borderRadiusClass]="class['frame-blank']"
        [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
      <!-- Bo tròn -->
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 2">
      <app-animations-config
        [elementChoosing]="objectChoosing"
        [staticdata]="staticdata"
        [id_object]="objectChoosing._id"
        [customize]="customize"
        [device]="device"
      ></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 3">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <ng-container *ngIf="config['background-color']?.gradient_check">
        <div class="list-gradient">
          <button class="btn-gradient" *ngFor="
              let bgGradient of config['background-color']['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config['background-color'].gradient_check">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['frame-blank']['background-color']"
            type="button" [disabled]="!config['background-color'].gradient_check"
            [style.background]="class['frame-blank']['background-color']" (colorPickerClose)="addGradient($event)" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
          nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)"
          [disabled]="!config['background-color'].gradient_check" [style.background]="
            'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
          "></button>
      </ng-container>
    </div>
  </div>
</div>
